import React, { useEffect, useState } from "react";
import Layout from 'Layout'
import { mixGetV1 ,mixPutV1, mixDelV1  } from "services/mixin";
import { Modal } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import {
  Card,
  Button,
  Table,
  Input,
  Breadcrumb,
  Tag,
  Select,
  Pagination,
  message,
} from "antd";
import {
  HomeOutlined,
  RightOutlined,
  UserOutlined,
  DeleteOutlined,
  PhoneOutlined,
  StarOutlined,
  CheckOutlined,
  SearchOutlined,
} from "@ant-design/icons";

const PartnerDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>(); // <-- lấy ID từ URL
  const [loading, setLoading] = useState(true);
  const [partner, setPartner] = useState<any>(null);
  const [customers, setCustomers] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const total = 1;
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, total);
  const navigate = useNavigate();


  const columns = [
    {
      title: "MÃ",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "HỌ TÊN",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "TỔNG THANH TOÁN",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "SỐ ĐIỆN THOẠI",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      key: "email",
    },
  ];

  const data = [
    {
      key: 1,
      id: "#224",
      name: "test07@gmail.com",
      total: "0 VND",
      phone: "0963258741",
      email: "test07@gmail.com",
    },
  ];
   useEffect(() => {
     console.log("🟩 Partner ID:", id);
    if (id) getPartnerDetail(id);
  }, [id]);

  const getPartnerDetail = async (partnerId: string) => {
    try {
      setLoading(true);
      const res = await mixGetV1(`/api/v1/be/contact_affiliate/${partnerId}`);
      if (res?.status && res.data) {
        setPartner(res.data);
        setCustomers(res.data?.customers || []);
      } else {
        message.warning("Không tìm thấy thông tin đối tác");
      }
    } catch (err) {
      message.error("Lỗi khi tải thông tin chi tiết đối tác");
    } finally {
      setLoading(false);
    }
  };
  const handleAcceptPartner = async (id: number) => {
    try {
      const res = await mixPutV1(`/api/v1/be/contact_affiliate/${id}`, { status: 1 });

      if (res?.status) {
        message.success("Đã chấp nhận đối tác thành công!");
        setPartner((prev: any) => ({ ...prev, status: 1 }));
      } else {
        message.warning(res?.msg || "Không thể cập nhật trạng thái!");
      }
    } catch (err) {
      message.error("Lỗi khi cập nhật trạng thái đối tác!");
    }
  };
  const handleDeletePartner = (id: number) => {
    Modal.confirm({
      title: "Xác nhận xóa đối tác",
      content: "Bạn có chắc chắn muốn xóa đối tác này không",
      okText: "Xóa",
      cancelText: "Hủy",
      okButtonProps: { danger: true },
      icon: <DeleteOutlined style={{ color: "red" }} />,
      async onOk() {
        try {
          const res = await mixDelV1(`/api/v1/be/contact_affiliate/${id}`);
          if (res?.status) {
            message.success("Đã xóa đối tác thành công!");
            navigate("/doi-tac");
          } else {
            message.warning(res?.msg || "Không thể xóa đối tác!");
          }
        } catch (error) {
          message.error("Lỗi khi xóa đối tác!");
        }
      },
    });
  };


  return (
    <Layout>
      <div className="partners-page">
        <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <h2 style={{ fontWeight: 600, fontSize: 24, marginBottom: 0, color: "#6e6b7b", borderRight: "1px solid #d6dce1", paddingRight: 12 }}>
            Đối tác
          </h2>
          {/* Breadcrumb */}
          <Breadcrumb
            separator={<RightOutlined style={{ fontSize: 12, color: "#6e6b7b" }} />}
            items={[
              {
                title: (
                  <a href="#">
                    <HomeOutlined style={{ color: "#096dd9", fontSize: 16 }} />
                  </a>
                ),
              },
              {
                title: (
                  <a href="/doi-tac" style={{ color: "#6e6b7b" }}>
                    Đối tác
                  </a>
                )
              },
              { title: "Chi tiết" },
            ]}
          />
        </div>

        <div>
          {/* Header info */}
          <div className="partner-card-container">
            <Card className="partner-card-left-middle">
              <div className="f-direction-cl-767" style={{ display: 'flex', gap: 16 }}>
                {/* Left */}
                <div style={{ flex: 1 }}>
                  <div className="partner-left-top">
                    <div className="avatar">
                      <UserOutlined />
                    </div>
                    <div className="user-info">
                      <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 0 }}>{partner?.customer.fullname || "No name"}</h3>
                      <p style={{ marginBottom: 16 }}>{partner?.customer.email || "-"}</p>
                      {partner?.status === 1 ? (
                        <Tag color="green" style={{ fontSize: 14, padding: "6px 12px" }}>
                          Đã trở thành đối tác
                        </Tag>
                      ) : (
                        <Button
                          type="primary"
                          icon={<CheckOutlined />}
                          onClick={() => handleAcceptPartner(partner?.id)}
                          style={{ background: "#28c76f", borderColor: "#28c76f" }}
                        >
                          Chấp nhận đối tác
                        </Button>
                      )}

                      <Button danger icon={<DeleteOutlined />}  onClick={() => handleDeletePartner(partner?.id)} style={{ borderRadius: 6, fontWeight: 500 }}>Xóa</Button>
                    </div>
                  </div>
                  <div className="partner-left-stats partner-left-stats-block">
                    <div className="stat-card">
                      <div className="icon-svg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-trending-up"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
                      </div>
                      <div className="text">
                        <span style={{ fontSize: 18, fontWeight: 500, lineHeight: 1.2, color: "#5e5873", textAlign: "left", display: "block" }}>Chưa có đơn</span>
                        <p style={{ fontSize: 14, color: "#6e6b7b", textAlign: "left" }}>Đơn hàng: <strong>100</strong></p>
                      </div>
                    </div>
                    <div className="stat-card">
                      <div className="icon-svg cl-28c76f">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-dollar-sign"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                      </div>
                      <div className="text">
                        <span style={{ fontSize: 18, fontWeight: 500, lineHeight: 1.2, color: "#5e5873", textAlign: "left", display: "block" }}>Chưa chi tiêu</span>
                        <p style={{ fontSize: 14, color: "#6e6b7b", textAlign: "left" }}>Tổng tiền: <strong>1.000.000 VNĐ</strong></p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Middle */}
                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex", gap: 8, marginBottom: "20px" }}>
                    <div style={{ display: "flex", gap: 8, width: 150, fontWeight: 600, color: "#6e6b7b" }}>
                      <CheckOutlined /> Trạng thái
                    </div>
                    <span style={{ color: "#6e6b7b" }}>{partner?.status === 1 ? "Đã trở thành đối tác" : "Chưa trở thành đối tác"}</span>
                  </div>
                  <div style={{ display: "flex", gap: 8, marginBottom: "20px" }}>
                    <div style={{ display: "flex", gap: 8, width: 150, fontWeight: 600, color: "#6e6b7b" }}>
                      <StarOutlined /> Phân loại
                    </div>
                    <span style={{ color: "#6e6b7b" }} >Đối tác</span>
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <div style={{ display: "flex", gap: 8, width: 150, fontWeight: 600, color: "#6e6b7b" }}>
                      <PhoneOutlined /> Liên hệ
                    </div>
                    <span style={{ color: "#6e6b7b" }}>{partner?.customer.phone || "-"}</span>
                  </div>
                </div>
              </div>
            </Card>

            <Card className="partner-card-right">
              <p>Mã ID: <Tag color="blue">#0224</Tag></p>
              <p>Ngày đăng ký: <Tag color="green">{partner?.created_at || "-"}</Tag></p>
              <p>Hoạt động lần cuối: <Tag color="red">{partner?.updated_at || "-"}</Tag></p>
            </Card>
          </div>

          {/* Customer list */}
          <div className="card-like"
            style={{ marginTop: 24, borderRadius: 12, padding: 0, flexWrap: "wrap" }}
          >
            <div
              className="f-direction-cl-767 gap-8-767"
              style={{
                display: "flex",
                gap: 8,
                padding: 16,
              }}
            >
              <h2 style={{ fontWeight: 600, fontSize: 20, marginBottom: 0, color: "#6e6b7b" }}>
                Danh sách khách hàng
              </h2>
              <Input
                placeholder="Tìm nhanh theo tên/phone/email"
                prefix={<SearchOutlined />}
                style={{ width: 320, height: 38, marginLeft: 'auto' }}
                className="control-38 ml-0-767"
              />
              <Button
                type="primary"
                style={{
                  background: "#007bff",
                  height: 38,
                  borderRadius: 6,
                  fontWeight: 500,
                }}
              >
                Chọn khách hàng
              </Button>
              <Button
                type="primary"
                style={{
                  background: "#007bff",
                  height: 38,
                  borderRadius: 6,
                  fontWeight: 500,
                }}
              >
                Export
              </Button>
            </div>

            <Table
              className="custom-table"
              columns={columns}
              dataSource={data}
              pagination={false}
              rowKey="key"
              size="middle"
              bordered={false}
              scroll={{ x: '800px' }}
            />
            <div className="partners-pagination" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 16, padding: '0 16px 16px 16px' }}>
              <div className="info-text">
                Showing {start} to {end} of {total} entries
              </div>

              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={total}
                onChange={(page) => setCurrentPage(page)}
                showSizeChanger={false}
                className="custom-pagination"
              />
            </div>
          </div>
        </div>
      </div >
    </Layout >
  );
};

export default PartnerDetailPage;
